import {Button} from 'react-bootstrap';
import {useModal} from '../../../hooks/useModal';
import {useIntl} from 'react-intl';
import CardComponent from '../../../common/components/CardComponent';
import {useQuery} from 'react-query';
import {getRib} from '../api';
import Loading from '../../../common/components/Loading';
import PaymentInfosSummary from './PaymentInfosSummary';
import RibModalManager from './RIBModalManager';
import {Entity} from '../../../modules/auth/authorization/api';
import {useState} from 'react';
import SelectEntity from './SelectEntity';
import {useEntities} from '../../../modules/auth/authorization/PermissionProvider';

const PaymentModeCard = (): JSX.Element => {
    const intl = useIntl();
    const {isDisplayed, showModal, hideModal} = useModal();
    const entities = useEntities();
    const [currentEntity, setCurrentEntity] = useState<Entity>(entities[0]);

    const useRib = () => useQuery(['rib', currentEntity], () => getRib(currentEntity.id));

    const {data: rib, isLoading, isSuccess, refetch} = useRib();

    if (isLoading) {
        return <Loading />;
    }

    if (!rib) {
        return <div></div>;
    }

    const modalButton = (
        <Button variant="light" type="button" onClick={showModal}>
            {intl.formatMessage({id: 'ADMINISTRATIVE.PAYMENT_MODE.RIB.SEE'})}
        </Button>
    );

    return (
        <CardComponent title={intl.formatMessage({id: 'ADMINISTRATIVE.PAYMENT_MODE.TITLE'})} {...(isSuccess && {footer: modalButton})}>
            {entities.length > 1 ? (
                <div className="pb-5">
                    <SelectEntity
                        setFieldValue={setCurrentEntity}
                        value={currentEntity}
                        entities={entities}
                    />
                </div>
            ) : (
                <></>
            )}
            {isSuccess ? (
                <>
                    <PaymentInfosSummary rib={rib} isLoading={isLoading} />
                    <RibModalManager
                        rib={rib}
                        show={isDisplayed}
                        hide={hideModal}
                        entity={currentEntity}
                        refetch={refetch}
                    />
                </>
            ) : (
                <p className="text-center">
                    {intl.formatMessage({id: 'ADMINISTRATIVE.PAYMENT_MODE.NOTHING'})}
                </p>
            )}
        </CardComponent>
    );
};

export default PaymentModeCard;
